import { NgModule } from '@angular/core';
import { httpInterceptors } from './interceptors/http-interceptors';

@NgModule({
  imports: [],
  providers: [
    ...httpInterceptors /*provideHttpClient(withInterceptorsFromDi())*/,
  ],
})
export class CoreModule {}
